// @ts-nocheck — duplicate message keys are intentional (last wins); file is data-only.
/* Reactify Langs

Translations Squence

01.Topbar
02. Offcanvas Menu
03. Breadcrumbs
*/

const messages = {
  // Top Navbar Translations
  "menu.search": "Search...",
  "topbar.messages": "Messages",
  "topbar.mark-all": "Mark All",
  "topbar.view-all": "View All",

  // Offcanvas Menu
  "menu.main": "Dasboards",
  "menu.dashboard": "Main Layout",
  "topbar.mark-all": "Mark All",
  "topbar.view-all": "View All",

  // Breadcrumbs
  "menu.default": "Default",
  "menu.layout": "Main Layout",
  "menu.team-message": "Conversation",
  "menu.app": "Home",
  "menu.adverts": "Adverts",
  "menu.saas-crm": "SaaS / CRM",
  "menu.analytics": "Analytics",
  "menu.ecommerce": "eCommerce admin",
  "menu.finance": "Finance",
  "menu.industrial": "Industrial",
  "menu.ai-studio": "AI Studio",
  "menu.devops": "DevOps / SRE",
  "menu.subscription-plg": "Subscription / PLG",
  "menu.hr-people": "HR / People",
  "menu.logistics": "Logistics",
  "menu.healthcare": "Healthcare",
  "menu.education": "Education / LMS",
  "menu.real-estate": "Real estate",
  "menu.security": "Security / SOC",

  "suite.nav.overview": "Overview",
  "suite.col.actions": "Actions",
  "suite.col.id": "ID",
  "suite.col.title": "Title",
  "suite.col.name": "Name",
  "suite.col.status": "Status",
  "suite.col.type": "Type",
  "suite.col.time": "Time",
  "suite.col.subject": "Subject",
  "suite.col.priority": "Priority",
  "suite.col.assignee": "Assignee",
  "suite.col.tier": "Tier",
  "suite.col.region": "Region",
  "suite.col.contacts": "Contacts",
  "suite.col.shortcut": "Shortcut",
  "suite.col.updated": "Updated",
  "suite.col.author": "Author",
  "suite.col.views": "Views",
  "suite.col.post": "Post",
  "suite.col.body": "Body",
  "suite.col.folder": "Folder",
  "suite.col.size": "Size",
  "suite.col.resource": "Resource",
  "suite.col.expires": "Expires",
  "suite.col.permissions": "Permissions",
  "suite.col.spend": "Spend",
  "suite.col.roas": "ROAS",
  "suite.col.stage": "Stage",
  "suite.col.value": "Value",
  "suite.col.owner": "Owner",
  "suite.col.email": "Email",
  "suite.col.schedule": "Schedule",
  "suite.col.sku": "SKU",
  "suite.col.price": "Price",
  "suite.col.stock": "Stock",
  "suite.col.customer": "Customer",
  "suite.col.total": "Total",
  "suite.col.channel": "Channel",
  "suite.col.order": "Order",
  "suite.col.reason": "Reason",
  "suite.col.amount": "Amount",
  "suite.col.client": "Client",
  "suite.col.due": "Due",
  "suite.col.invoice": "Invoice",
  "suite.col.method": "Method",
  "suite.col.date": "Date",
  "suite.col.vendor": "Vendor",
  "suite.col.category": "Category",
  "suite.col.period": "Period",
  "suite.col.department": "Department",
  "suite.col.planned": "Planned",
  "suite.col.actual": "Actual",
  "suite.col.variance": "Variance",
  "suite.col.site": "Site",
  "suite.col.oee": "OEE",
  "suite.col.severity": "Severity",
  "suite.col.message": "Message",
  "suite.col.asset": "Asset",
  "suite.col.env": "Environment",
  "suite.col.budget": "Budget (USD)",
  "suite.col.used": "Used (USD)",
  "suite.col.label": "Label",
  "suite.col.prefix": "Prefix",
  "suite.col.created": "Created",
  "suite.col.lastUsed": "Last used",
  "suite.col.model": "Model",
  "suite.col.tokens": "Tokens",
  "suite.col.traffic": "Traffic %",
  "suite.col.latency": "Latency (ms)",
  "suite.col.company": "Company",
  "suite.col.started": "Started",
  "suite.col.step": "Step",
  "suite.col.score": "Score",
  "suite.col.adoption": "Adoption",
  "suite.col.target": "Target",
  "suite.col.mrrLost": "MRR lost",
  "suite.col.saved": "Saved",
  "suite.col.daysOpen": "Days open",
  "suite.col.employee": "Employee",
  "suite.col.range": "Range",
  "suite.col.location": "Location",
  "suite.col.dept": "Department",
  "suite.col.lane": "Lane",
  "suite.col.carrier": "Carrier",
  "suite.col.eta": "ETA",
  "suite.col.otd": "OTD %",
  "suite.col.volume": "Volume",
  "suite.col.code": "Code",
  "suite.col.util": "Utilization %",
  "suite.col.throughput": "Throughput",
  "suite.col.patient": "Patient",
  "suite.col.provider": "Provider",
  "suite.col.payer": "Payer",
  "suite.col.learners": "Learners",
  "suite.col.completion": "Completion %",
  "suite.col.active": "Active %",
  "suite.col.coursesActive": "Active courses",
  "suite.col.address": "Address",
  "suite.col.dom": "DOM",
  "suite.col.source": "Source",
  "suite.col.interest": "Interest",
  "suite.col.property": "Property",
  "suite.col.buyer": "Buyer",
  "suite.col.closeDate": "Close date",
  "suite.col.cvss": "CVSS",
  "suite.col.sla": "SLA",
  "suite.col.evidence": "Evidence",
  "suite.col.actor": "Actor",
  "suite.col.action": "Action",
  "suite.col.target": "Target",
  "suite.col.compliant": "Compliance %",
  "suite.col.posts": "Posts",
  "suite.col.slug": "Slug",
  "suite.col.mrr": "MRR",
  "suite.col.health": "Health",
  "suite.col.rotation": "Rotation",
  "suite.col.version": "Version",
  "suite.col.ago": "When",
  "suite.action.open": "Open",
  "suite.action.back": "Back",
  "suite.action.save": "Save",
  "suite.state.error": "Error",
  "suite.state.empty": "No rows to display.",
  "suite.state.notfound": "Record not found.",
  "suite.search.placeholder": "Filter…",
  "suite.main.notifications": "Notifications",
  "suite.main.search": "Search",
  "suite.main.shortcuts": "Shortcuts",
  "suite.main.search-results": "Results",
  "suite.main.shortcut-finance": "Finance overview",
  "suite.main.shortcut-tickets": "Open ticket queue",
  "suite.main.shortcut-finance-sub": "Invoices, payments, budgets",
  "suite.main.shortcut-tickets-sub": "Queue, SLA, macros",
  "suite.ticketing.tickets": "Ticket queue",
  "suite.ticketing.customers": "Organizations",
  "suite.ticketing.macros": "Macros",
  "suite.ticketing.sla": "SLA settings",
  "suite.ticketing.ticket-detail": "Ticket",
  "suite.ticketing.thread": "Conversation",
  "suite.ticketing.sidebar": "Actions",
  "suite.ticketing.sidebar-body": "Link macros, change assignee, and post internal notes from your backend.",
  "suite.ticketing.reply": "Post reply",
  "suite.ticketing.insert-macro": "Insert macro",
  "suite.ticketing.sla-first": "First response (minutes)",
  "suite.ticketing.sla-resolution": "Resolution target (minutes)",
  "suite.ticketing.sla-hours": "Business hours",
  "suite.ticketing.customer-detail": "Organization",
  "suite.ticketing.sla-badge": "SLA at risk",
  "suite.ticketing.queue-empty": "No tickets match this view.",
  "suite.ticketing.summary-total": "tickets",
  "suite.ticketing.bulk-assign-demo": "Bulk assign (demo)",
  "suite.ticketing.macro-preview-panel": "Macro quick preview",
  "suite.ticketing.macro-uses": "Uses (30d)",
  "suite.ticketing.all-macros": "All macros",
  "suite.blogging.posts": "Posts",
  "suite.blogging.categories": "Categories",
  "suite.blogging.media": "Media library",
  "suite.blogging.comments": "Comments",
  "suite.blogging.post-detail": "Post",
  "suite.storage.files": "Files",
  "suite.storage.shares": "Shared links",
  "suite.storage.settings": "Storage settings",
  "suite.storage.file-detail": "File",
  "suite.storage.version-history": "Version history",
  "suite.storage.activity": "Recent activity",
  "suite.storage.shares-hint": "Copy expiring links to clipboard — audit trail would log each access.",
  "suite.storage.quota": "Quota (GB)",
  "suite.storage.retention": "Retention (days)",
  "suite.adverts.campaigns": "Campaigns",
  "suite.adverts.reports": "Performance",
  "suite.adverts.billing": "Billing",
  "suite.adverts.campaign-detail": "Campaign",
  "suite.crm.deals": "Deals",
  "suite.crm.accounts": "Accounts",
  "suite.crm.contacts": "Contacts",
  "suite.crm.activities": "Activities",
  "suite.crm.deal-detail": "Deal",
  "suite.crm.account-detail": "Account",
  "suite.analytics.reports": "Saved reports",
  "suite.analytics.builder": "Report builder",
  "suite.analytics.exports": "Exports",
  "suite.analytics.report-detail": "Report",
  "suite.analytics.field-dataset": "Dataset",
  "suite.analytics.field-dimensions": "Dimensions",
  "suite.analytics.field-metrics": "Metrics",
  "suite.ecom.products": "Products",
  "suite.ecom.orders": "Orders",
  "suite.ecom.customers": "Customers",
  "suite.ecom.returns": "Returns",
  "suite.ecom.product-detail": "Product",
  "suite.ecom.order-detail": "Order",
  "suite.ecom.customer-detail": "Customer",
  "suite.finance.invoices": "Invoices",
  "suite.finance.payments": "Payments",
  "suite.finance.expenses": "Expenses",
  "suite.finance.budgets": "Budgets",
  "suite.finance.invoice-detail": "Invoice",
  "suite.industrial.assets": "Assets",
  "suite.industrial.alerts": "Alerts",
  "suite.industrial.workorders": "Work orders",
  "suite.industrial.asset-detail": "Asset",
  "suite.industrial.workorder-detail": "Work order",
  "suite.aistudio.projects": "Projects",
  "suite.aistudio.keys": "API keys",
  "suite.aistudio.logs": "Usage logs",
  "suite.aistudio.experiments": "Experiments",
  "suite.aistudio.settings": "Rate limits",
  "suite.aistudio.project-detail": "Project",
  "suite.aistudio.rpm-limit": "Requests per minute limit",
  "suite.aistudio.monthly-budget": "Monthly budget (USD)",
  "suite.devops.services": "Services",
  "suite.devops.incidents": "Incidents",
  "suite.devops.deploys": "Deployments",
  "suite.devops.runbooks": "Runbooks",
  "suite.devops.oncall": "On-call",
  "suite.devops.service-detail": "Service",
  "suite.devops.incident-detail": "Incident",
  "suite.devops.deploys-hint": "Expand each row for commit messages and a placeholder diff summary.",
  "suite.devops.diff-placeholder": "Changed paths (stub)",
  "suite.plg.accounts": "Accounts",
  "suite.plg.trials": "Trials",
  "suite.plg.features": "Feature adoption",
  "suite.plg.churn": "Churn & saves",
  "suite.plg.account-detail": "Account",
  "suite.hr.employees": "Employees",
  "suite.hr.requisitions": "Job requisitions",
  "suite.hr.timeoff": "Time off",
  "suite.hr.settings": "HR settings",
  "suite.hr.employee-detail": "Employee",
  "suite.hr.requisition-detail": "Requisition",
  "suite.hr.default-location": "Default location",
  "suite.hr.work-week": "Work week",
  "suite.logistics.shipments": "Shipments",
  "suite.logistics.carriers": "Carriers",
  "suite.logistics.warehouses": "Warehouses",
  "suite.logistics.exceptions": "Exceptions",
  "suite.logistics.shipment-detail": "Shipment",
  "suite.health.appointments": "Appointments",
  "suite.health.claims": "Claims",
  "suite.health.providers": "Providers",
  "suite.health.appointment-detail": "Appointment",
  "suite.health.claim-detail": "Claim",
  "suite.edu.courses": "Courses",
  "suite.edu.cohorts": "Cohorts",
  "suite.edu.learners": "Learners",
  "suite.edu.course-detail": "Course",
  "suite.edu.cohort-detail": "Cohort",
  "suite.edu.learner-detail": "Learner",
  "suite.re.listings": "Listings",
  "suite.re.leads": "Leads",
  "suite.re.transactions": "Transactions",
  "suite.re.listing-detail": "Listing",
  "suite.sec.vulns": "Vulnerabilities",
  "suite.sec.policies": "Policies",
  "suite.sec.audit": "Audit log",
  "suite.sec.vuln-detail": "Finding",

  "suite.mock.pagination-range": "Showing",
  "suite.mock.pagination-of": "of",
  "suite.mock.pagination-label": "Mock pagination",
  "suite.mock.page-size": "Rows",
  "suite.overview.quick-links": "Jump into",

  "hr.hero.headline": "People operations snapshot",
  "hr.hero.sub": "Hiring velocity, engagement signals, and compliance tasks in one view — wired for demo data.",
  "hr.hero.open-ats": "Open ATS",
  "hr.section.news": "HR announcements",
  "hr.kpi.headcount": "Headcount",
  "hr.kpi.open-roles": "Open roles",
  "hr.kpi.tth": "Avg. time-to-hire",
  "hr.kpi.turnover": "Annualized turnover",
  "hr.kpi.engagement": "Engagement index",
  "hr.kpi.reviews": "Reviews due",
  "hr.kpi.out": "Out today",
  "hr.chart.funnel": "Hiring funnel (all reqs)",
  "hr.chart.tth": "Time-to-hire trend",
  "hr.chart.dept": "Headcount vs open reqs by department",
  "hr.chart.diversity": "Workforce representation (self-ID)",
  "hr.chart.pto": "PTO utilization by team (YTD)",
  "hr.section.org": "Leadership coverage",
  "hr.org.reports": "directs",
  "hr.table.roles": "Priority open roles",
  "hr.section.reviews": "Performance reviews",
  "hr.col.title": "Role",
  "hr.col.dept": "Department",
  "hr.col.location": "Location",
  "hr.col.stage": "Stage",
  "hr.col.days": "Days open",
  "hr.col.name": "Employee",
  "hr.col.role": "Title",
  "hr.col.due": "Due",
  "hr.col.type": "Cycle",

  "logistics.hero.title": "Network control tower",
  "logistics.hero.sub": "Lane health, carrier scorecards, and exception triage — illustrative logistics data.",
  "logistics.hero.dispatch": "Dispatch board",
  "logistics.hero.export": "Export CSV",
  "logistics.section.ops-alerts": "Ops alerts",
  "logistics.kpi.routes": "Active routes",
  "logistics.kpi.ontime": "On-time delivery",
  "logistics.kpi.exceptions": "Open exceptions",
  "logistics.kpi.transit": "Avg. transit",
  "logistics.kpi.wh-util": "Warehouse utilization",
  "logistics.kpi.cpp": "Cost / package",
  "logistics.map.title": "Hub load (schematic)",
  "logistics.map.caption": "Relative outbound volume by hub — not a live map.",
  "logistics.map.legend": "Pill = airport code · number = daily load index (demo)",
  "logistics.chart.sla": "On-time % vs target (rolling week)",
  "logistics.chart.carrier-otd": "Carrier on-time delivery",
  "logistics.chart.carrier-vol": "Volume by carrier (units)",
  "logistics.chart.warehouse": "Inbound vs outbound pallets",
  "logistics.table.exceptions": "Exception queue",
  "logistics.table.fleet": "Fleet snapshot",
  "logistics.col.id": "ID",
  "logistics.col.type": "Type",
  "logistics.col.lane": "Lane",
  "logistics.col.severity": "Severity",
  "logistics.col.age": "Age",
  "logistics.col.truck": "Asset",
  "logistics.col.driver": "Driver",
  "logistics.col.origin": "Origin",
  "logistics.col.dest": "Destination",
  "logistics.col.eta": "ETA",
  "logistics.col.status": "Status",

  "health.disclaimer.title": "Demo UI only.",
  "health.disclaimer.body": "This screen uses fictional patients and metrics for layout demonstration only. It is not for protected health information and does not imply HIPAA compliance.",
  "health.kpi.appts": "Appointments today",
  "health.kpi.checkin": "Checked in",
  "health.kpi.wait": "Avg. wait",
  "health.kpi.noshow": "No-show rate",
  "health.kpi.providers": "Providers on duty",
  "health.kpi.csat": "Satisfaction",
  "health.kpi.revenue": "Est. day revenue",
  "health.table.schedule": "Today’s schedule",
  "health.table.queue": "Waiting room",
  "health.chart.providers": "Provider utilization",
  "health.chart.dept-wait": "Avg. wait by department",
  "health.chart.billing": "Payer mix (demo)",
  "health.chart.noshow": "No-show trend",
  "health.section.patients-day": "Patients seen vs utilization",
  "health.table.claims": "Claims pipeline",
  "health.col.time": "Time",
  "health.col.patient": "Patient",
  "health.col.provider": "Provider",
  "health.col.room": "Room",
  "health.col.type": "Visit type",
  "health.col.status": "Status",
  "health.col.ticket": "Ticket",
  "health.col.wait": "Wait",
  "health.col.priority": "Priority",
  "health.col.dept": "Department",
  "health.col.claim": "Claim",
  "health.col.payer": "Payer",
  "health.col.amount": "Amount",
  "health.col.age": "Age",
  "health.col.patients": "Patients",
  "health.col.util": "Utilization",

  "edu.hero.title": "Learning & certification hub",
  "edu.hero.sub": "Cohort progress, course health, and instructor impact — powered by demo enrollments.",
  "edu.hero.cohort": "New cohort",
  "edu.section.news": "L&D notices",
  "edu.kpi.learners": "Active learners",
  "edu.kpi.courses": "Live courses",
  "edu.kpi.completion": "Completion rate",
  "edu.kpi.certs": "Certificates (30d)",
  "edu.kpi.score": "Avg. assessment score",
  "edu.kpi.nps": "Learner NPS",
  "edu.kpi.revenue": "Revenue",
  "edu.chart.enrollment": "Enrollments vs completions",
  "edu.chart.funnel": "Course completion funnel",
  "edu.chart.activity": "Learning hours by weekday",
  "edu.chart.segments": "Learners by segment",
  "edu.section.cohorts": "Active cohorts",
  "edu.cohort.learners": "learners",
  "edu.cohort.active": "active this week",
  "edu.table.courses": "Top courses",
  "edu.table.instructors": "Instructor leaderboard",
  "edu.col.course": "Course",
  "edu.col.enrolled": "Enrolled",
  "edu.col.completion": "Completion",
  "edu.col.rating": "Rating",
  "edu.col.instructor": "Instructor",
  "edu.col.courses": "Courses",

  "re.hero.title": "Listings & pipeline command center",
  "re.hero.new-listing": "New listing",
  "re.hero.tour": "Schedule tour",
  "re.section.hot": "Hot & new listings",
  "re.kpi.listings": "Active listings",
  "re.kpi.new": "New (7d)",
  "re.kpi.dom": "Avg. days on market",
  "re.kpi.pipeline": "Pipeline value",
  "re.kpi.leads": "Leads (week)",
  "re.kpi.viewings": "Viewings (week)",
  "re.kpi.cvr": "lead→view CVR",
  "re.chart.pipeline-count": "Listings by pipeline stage",
  "re.chart.pipeline-value": "Pipeline value ($M) by stage",
  "re.chart.leads": "Leads by source",
  "re.chart.dom": "Days on market trend",
  "re.chart.price": "Inventory by price band",
  "re.section.viewings": "Upcoming viewings",
  "re.table.agents": "Agent performance (90d)",
  "re.col.agent": "Agent",
  "re.col.listings": "Listings",
  "re.col.volume": "Volume",
  "re.col.deals": "Deals",
  "re.col.when": "When",
  "re.col.property": "Property",
  "re.col.type": "Type",

  "sec.hero.title": "Security posture overview",
  "sec.hero.sub": "Vulnerability backlog, auth abuse signals, and policy adherence — demo telemetry only.",
  "sec.hero.scan": "Run assessment",
  "sec.hero.report": "Export exec summary",
  "sec.section.threat": "Threat intel highlights",
  "sec.kpi.score": "Posture score",
  "sec.kpi.score-delta": "vs last month",
  "sec.kpi.vulns": "Open findings",
  "sec.kpi.critical": "critical",
  "sec.kpi.patch": "Mean time to patch",
  "sec.kpi.policies": "Policy compliance",
  "sec.kpi.logins": "failed logins (24h)",
  "sec.kpi.incidents": "open incidents",
  "sec.chart.vuln-stack": "Findings by severity — open vs remediated",
  "sec.chart.vuln-trend": "Opened vs closed (weekly)",
  "sec.chart.regions": "Failed logins & blocks by region",
  "sec.section.policies": "Control checklist",
  "sec.table.vulns": "Priority CVE queue",
  "sec.table.audit": "Security audit stream",
  "sec.col.cve": "CVE",
  "sec.col.asset": "Asset",
  "sec.col.cvss": "CVSS",
  "sec.col.sla": "SLA",
  "sec.col.age": "Age",
  "sec.col.time": "Time",
  "sec.col.actor": "Actor",
  "sec.col.action": "Action",
  "sec.col.target": "Target",

  "ai-studio.hero.budget": "Monthly budget used",
  "ai-studio.hero.adjust": "Limits",
  "ai-studio.hero.rpm": "Requests per minute",
  "ai-studio.section.alerts": "Recent alerts",
  "ai-studio.kpi.tokens": "Tokens (24h)",
  "ai-studio.kpi.latency": "Avg latency",
  "ai-studio.kpi.errors": "Error rate",
  "ai-studio.kpi.keys": "Active API keys",
  "ai-studio.chart.models": "Requests by model",
  "ai-studio.chart.cost": "Cost & token volume",
  "ai-studio.chart.latency": "Latency by hour (p50)",
  "ai-studio.section.keys": "API key health",
  "ai-studio.table.experiments": "Experiments",
  "ai-studio.table.prompts": "Recent prompts (sample)",
  "ai-studio.col.experiment": "Experiment",
  "ai-studio.col.model": "Model",
  "ai-studio.col.status": "Status",
  "ai-studio.col.traffic": "Traffic %",
  "ai-studio.col.id": "Request",
  "ai-studio.col.preview": "Preview",
  "ai-studio.col.tokens": "Tokens",

  "devops.slo.target": "SLO target",
  "devops.slo.actual": "Rolling availability",
  "devops.slo.budget": "Error budget left",
  "devops.slo.burn": "Burn rate (30d)",
  "devops.chart.errors": "Error rate & deploys",
  "devops.section.oncall": "On-call",
  "devops.oncall.primary": "Primary",
  "devops.oncall.secondary": "Secondary",
  "devops.section.services": "Service health",
  "devops.section.deploys": "Deployments",
  "devops.section.incidents": "Incidents",
  "devops.section.audit": "Change audit tail",
  "devops.col.title": "Title",
  "devops.col.severity": "Severity",
  "devops.col.state": "State",
  "devops.col.time": "Time",
  "devops.col.who": "Actor",
  "devops.col.what": "Change",

  "plg.hero.nps": "NPS (rolling)",
  "plg.hero.survey": "Details",
  "plg.hero.trials": "Active trials",
  "plg.hero.activation": "7d activation rate",
  "plg.kpi.mrr": "MRR",
  "plg.kpi.arr": "ARR",
  "plg.kpi.churn": "Logo churn",
  "plg.kpi.expansion": "Expansion MRR",
  "plg.chart.funnel": "Self-serve trial funnel",
  "plg.chart.growth": "New vs churn MRR",
  "plg.chart.features": "Feature adoption",
  "plg.chart.csat": "CSAT breakdown",
  "plg.section.milestones": "Growth milestones",
  "plg.table.accounts": "Strategic accounts",
  "plg.col.account": "Account",
  "plg.col.plan": "Plan",
  "plg.col.mrr": "MRR",
  "plg.col.health": "Health",
  "plg.col.stage": "Stage",

  "saas-crm.col.deal": "Deal",
  "saas-crm.col.company": "Company",
  "saas-crm.col.owner": "Owner",
  "saas-crm.col.stage": "Stage",
  "saas-crm.col.value": "Value",
  "saas-crm.col.close": "Close date",
  "saas-crm.col.health": "Health",
  "saas-crm.col.account": "Account",
  "saas-crm.col.tier": "Tier",
  "saas-crm.col.seats": "Seats",
  "saas-crm.kpi.mrr": "MRR",
  "saas-crm.kpi.arr": "ARR",
  "saas-crm.kpi.churn": "Churn",
  "saas-crm.kpi.logo": "Expansion",
  "saas-crm.kpi.accounts": "Active accounts",
  "saas-crm.kpi.trials": "Active trials",
  "saas-crm.kpi.pipeline-value": "Pipeline value",
  "saas-crm.kpi.won-deals": "Closed won (stage)",
  "saas-crm.kpi.quick-actions": "Quick actions",
  "saas-crm.action.new-deal": "New deal",
  "saas-crm.chart.mrr-trend": "MRR & new logo revenue",
  "saas-crm.chart.plan-mix": "Subscription plan mix",
  "saas-crm.chart.pipeline": "Pipeline by stage",
  "saas-crm.section.accounts": "Account health",
  "saas-crm.section.tasks": "Tasks due",
  "saas-crm.section.activity": "Today’s activity",
  "saas-crm.table.deals": "Open opportunities",

  "analytics.realtime.active": "Active right now",
  "analytics.realtime.live": "Live view",
  "analytics.realtime.events": "Events per minute",
  "analytics.kpi.sessions": "Sessions",
  "analytics.kpi.users": "Users",
  "analytics.kpi.bounce": "Bounce rate",
  "analytics.kpi.session-time": "Avg. session time",
  "analytics.kpi.conversions": "Conversions",
  "analytics.kpi.pageviews": "Page views",
  "analytics.kpi.funnel-start": "Funnel — top",
  "analytics.kpi.funnel-paid": "Funnel — paid",
  "analytics.chart.funnel": "Acquisition funnel",
  "analytics.chart.channels": "Sessions by channel",
  "analytics.chart.trend": "Sessions & events trend",
  "analytics.chart.devices": "Device mix",
  "analytics.section.retention": "Cohort retention",
  "analytics.section.goals": "Goals vs target",
  "analytics.table.pages": "Top pages",
  "analytics.table.events": "Top events",
  "analytics.section.live-stream": "Live event stream",
  "analytics.col.path": "Path",
  "analytics.col.views": "Views",
  "analytics.col.exit": "Exit rate",
  "analytics.col.event": "Event",
  "analytics.col.count": "Count",
  "analytics.col.time": "Time",
  "analytics.col.detail": "Detail",

  "ecom.toolbar.new-order": "New order",
  "ecom.toolbar.export": "Export",
  "ecom.toolbar.sync": "Sync channels",
  "ecom.kpi.revenue": "Revenue",
  "ecom.kpi.orders": "Orders",
  "ecom.kpi.aov": "AOV",
  "ecom.kpi.returns": "Return rate",
  "ecom.kpi.abandon": "Cart abandon",
  "ecom.kpi.cvr": "Conversion rate",
  "ecom.kpi.shipping": "On-time shipping",
  "ecom.kpi.skus-active": "Tracked SKUs",
  "ecom.chart.sales-week": "Orders & revenue (week)",
  "ecom.chart.order-status": "Orders by status",
  "ecom.chart.segments": "Customers by segment",
  "ecom.section.inventory": "Inventory alerts",
  "ecom.section.top-skus": "Top SKUs",
  "ecom.section.shipments": "Shipments in flight",
  "ecom.label.eta": "ETA",
  "ecom.table.orders": "Recent orders",
  "ecom.section.refunds": "Recent refunds",
  "ecom.col.order": "Order",
  "ecom.col.customer": "Customer",
  "ecom.col.items": "Items",
  "ecom.col.total": "Total",
  "ecom.col.status": "Status",
  "ecom.col.channel": "Channel",
  "ecom.col.date": "Date",
  "ecom.col.sku": "SKU",
  "ecom.col.product": "Product",
  "ecom.col.on-hand": "On hand",
  "ecom.col.reorder": "Reorder at",
  "ecom.col.severity": "Severity",
  "ecom.col.sold": "Sold",
  "ecom.col.stock": "Stock",

  "finance.toolbar.close-period": "Close period",
  "finance.toolbar.reports": "Financial reports",
  "finance.kpi.cash": "Cash on hand",
  "finance.kpi.runway": "Runway",
  "finance.kpi.months": "mo",
  "finance.kpi.burn": "Monthly burn",
  "finance.kpi.revenue-ytd": "Revenue YTD",
  "finance.kpi.ebitda": "EBITDA",
  "finance.kpi.ar": "Accounts receivable",
  "finance.kpi.ap": "Accounts payable",
  "finance.kpi.net-income": "Net income (Q)",
  "finance.section.pl": "P&L snapshot",
  "finance.pl.revenue": "Revenue",
  "finance.pl.cogs": "COGS",
  "finance.pl.opex": "Operating expenses",
  "finance.pl.other": "Other",
  "finance.pl.net": "Net income",
  "finance.chart.cashflow": "Cash flow",
  "finance.chart.budget": "Budget vs actual (opex)",
  "finance.chart.expenses": "Expense mix",
  "finance.section.aging": "A/R aging",
  "finance.table.invoices": "Invoices",
  "finance.chart.forecast": "Revenue & expense forecast",
  "finance.legend.budget": "Budget",
  "finance.legend.actual": "Actual",
  "finance.legend.revenue": "Revenue",
  "finance.legend.expenses": "Expenses",
  "finance.col.invoice": "Invoice",
  "finance.col.customer": "Customer",
  "finance.col.amount": "Amount",
  "finance.col.due": "Due",
  "finance.col.status": "Status",

  "industrial.toolbar.ack-alarms": "Acknowledge alarms",
  "industrial.toolbar.shift-report": "Shift report",
  "industrial.badge.active-alarms": "active alarms",
  "industrial.kpi.oee": "Plant OEE",
  "industrial.kpi.throughput": "Throughput (units)",
  "industrial.kpi.downtime": "Downtime",
  "industrial.kpi.quality": "First-pass quality",
  "industrial.kpi.energy": "Energy (day)",
  "industrial.kpi.work-orders": "Open work orders",
  "industrial.kpi.lines": "Production lines",
  "industrial.kpi.safety-days": "Days without LTI",
  "industrial.chart.output": "Output vs target",
  "industrial.chart.downtime": "Downtime reasons",
  "industrial.section.lines": "Line status",
  "industrial.label.output": "Output",
  "industrial.chart.energy": "Energy consumption",
  "industrial.chart.shifts": "Shift performance",
  "industrial.legend.planned": "Planned",
  "industrial.legend.actual": "Actual",
  "industrial.section.alarms": "Active alarms",
  "industrial.table.maintenance": "Maintenance queue",
  "industrial.section.safety": "Safety log",
  "industrial.col.wo": "Work order",
  "industrial.col.asset": "Asset",
  "industrial.col.type": "Type",
  "industrial.col.due": "Due",
  "industrial.col.priority": "Priority",
  "industrial.col.date": "Date",
  "industrial.col.area": "Area",
  "industrial.col.status": "Status",

  // Main Dashboard
  "main.weekly-sales": "Weekly Sales",
  "main.monthly-visits": "Monthly Vistors",
  "main.items-for-sale": "Items For Sales",
  "main.users": "Total Users",
  "main.sales": "Total Sales",
  "main.statistics": "Statistics",
  "main.traffic": "Traffic",
  "main.conversion": "Conversions",
  "main.bounce-rate": "Bounce Rate",
  "main.income": "Income",
  "main.order-status": "Order Status",
  "main.product-categories": "Product Categories",
  "main.tasks": "Tasks",
  "main.team-messages": "Team Messages",
  "team-message.title": "Team conversation",
  "team-message.subtitle": "Review the thread and send a reply.",
  "team-message.back-dashboard": "Back to dashboard",
  "team-message.thread": "Conversation",
  "team-message.last-activity": "Last activity",
  "team-message.you": "You",
  "team-message.reply-label": "Your reply",
  "team-message.reply-placeholder": "Write a message…",
  "team-message.send": "Send reply",
  "team-message.send-hint": "Tip: Ctrl+Enter (⌘+Enter on Mac) to send.",
  "team-message.not-found-title": "Conversation not found",
  "team-message.not-found-body": "That teammate or thread does not exist. Return to the main dashboard and pick a message from the list.",
  "main.total-online": "Total Online",
  "main.total-offline": "Total Offline",
  "main.popular-items": "Popular Items",
  "main.recent-activities": "Recent Activities",
  "main.customers-status": "Customers Status",
  "main.todays": "Today's",
  "main.weekly": "Weekly",
  "main.monthly": "Monthly",
  "main.yearly": "Yearly",
  "main.sales-progress": "Sales Progress",
  "main.sales-goal": "Sales Goal",
  "main.weather-forecast": "Weather Forecast",
  "main.city-name": "City Name",
  "main.country-name": "Country Name",
  "main.last-year-income": "Last Year Income",
  "main.get-weather-update": "Get Weather Update",
  "main.realtime-weather": "Realtime Weather",
  "main.last-year-sales-report": "Last Year Sales Report",

  // Ticketing Layout
  "main.ticketing": "Ticketing",
  "menu.ticketing": "Ticketing",
  "ticketing.products": "Products",
  "ticketing.tickets": "Tickets",
  "ticketing.users": "Users",
  "ticketing.settings": "Settings",
  "ticketing.monthly-sales": "Monthly Sales",
  "ticketing.income": "Income",
  "ticketing.taxes": "Taxes",
  "ticketing.todays-sales": "Todays Sales",
  "ticketing.weekly-tickets": "Weekly Tickets",
  "ticketing.weekly-tickets-progress": "Weekly Tickets Progress",
  "ticketing.by-date": "Tickets By Date",
  "ticketing.overdue": "Overdue",
  "ticketing.todays": "Today's",
  "ticketing.tomorrow": "Tomorrow's",
  "ticketing.this-week": "This Week",
  "ticketing.this-month": "This Month",
  "ticketing.close-tickets": "Closed Tickets",
  "ticketing.by-importance": "Tickets By Importance",
  "ticketing.high-importance": "High",
  "ticketing.medium": "Medium",
  "ticketing.low": "Low",
  "ticketing.replied": "Replied",
  "ticketing.transfered": "Transfered",
  "ticketing.on-hold": "On Hold",
  "ticketing.need-reply": "Awaiting Reply",
  "ticketing.recent-tickets": "Recent Tickets",
  "ticketing.backup-completed": "Backup Completed",
  "ticketing.servers-running": "All Servers Running",
  "ticketing.backup-failed": "Backup Failed",
  "ticketing.files-transferred": "Files Transferred",
  "ticketing.latest-updates": "Latest Updates",

  // Blogging

  "menu.blogging": "Blogging",
  "blogging.monthly-visits": "Monthly Visits",
  "blogging.subscribers": "Subscribers",
  "blogging.comments": "Comments",
  "blogging.approved": "Approved",
  "blogging.pending": "Pending",
  "blogging.spam": "Spam",
  "blogging.posts": "Posts",
  "blogging.categories": "Categories",
  "blogging.pages": "Pages",
  "blogging.tags": "Tags",
  "blogging.twitter": "Twitter",
  "blogging.facebook": "Facebook",
  "blogging.pinterest": "Pinterest",
  "blogging.rss": "RSS",
  "blogging.email": "Email",
  "blogging.traffic-source": "Traffic Source",
  "blogging.recent-comments": "Recent Comments",
  "blogging.edit": "Edit",
  "blogging.delete": "Delete",
  "blogging.posted": "Posted on",
  "blogging.popular-posts": "Popular Posts",
  "blogging.views": "Views",
  "blogging.comments": "Comments",

  // Storage
  "storage.menu": "Storage",
  "menu.storage": "Storage",
  "storage.files": "Files",
  "storage.zipped": "Zipped",
  "storage.photos": "Photos",
  "storage.videos": "Videos",
  "storage.temperature": "CPU Temperature",
  "storage.bandwidth": "Bandwidth Usage",
  "storage.max-value": "Max Value",
  "storage.min-value": "Min Value",
  "storage.total-storage": "Total Storage - PB",
  "storage.used-storage": "Used Storage - PB",
  "storage.todays-tip": "Today's Tip",
  "storage.tip-desc": "Upsell an experience, not an item.",
  "storage.social-interactions": "Social Interactions",
  "storage.target-more": "Target 9,500 or More",
  "storage.events": "Events",
  "storage.views": "Views",
  "storage.web-metric": "Key Web Metrics",
  "storage.target-or-less": "Target: 200:1 or less",
  "storage.average-ratio": "170:1 Visitors to Lead Ratio",
  "storage.visitors": "Visitors",
  "storage.leads": "Leads",
  "storage.site-events": "Site Events",
  "storage.uploads-metrics": "Uploads Metrics",
  "storage.uploads-target": "5:1 or less",
  "storage.making-uploads": "Making Uploads",
  "storage.recent": "Recent",
  "storage.per-minute": "Per Minute",
  "storage.load": "Load",

  // Adverts

  "adverts.todays-so-far": "Today's so far",
  "adverts.yesterday": "Yesterday",
  "adverts.last-week-same-day": "VS. same day last week",
  "adverts.last-week": "Last Week",
  "adverts.last-seven-days": "VS. Last 7 Days",
  "adverts.balance": "Balance",
  "adverts.last-payment": "Last Payment",

  // Shortcodes Menu

  "menu.shortcodes": "Shortcodes",
  "menu.buttons": "Buttons",
  "menu.social": "Social Buttons",
  "menu.badges": "Badges",
  "menu.tabs": "Tabs",
  "menu.progress": "Progress Bars",
  "menu.timeline": "Timeline",
  "menu.modals": "Modals",
  "menu.tooltip": "Tooltips",
  "menu.popover": "Popovers",
  "menu.panels": "Panels",
  "menu.carousel": "Carousels",
  "menu.columns": "Columns",
  "menu.typography": "Typography",
  "menu.pagination": "Pagination",
  "menu.player": "Player",
  "menu.alerts": "Alerts",
  "menu.forms": "Forms",
  "menu.tables": "Tables",
  "menu.charts": "Charts",
  "menu.emails": "E-Mails",
  "menu.editors": "Rich Editor",
  "emails.compose-email": "Compose E-Mail",
  // Buttons Page
  "button.reactify": "Reactify Buttons",
  "button.light": "Button Light",
  "button.primary": "Button Primary",
  "button.secondary": "Secondary",
  "button.info": "Button Info",
  "button.danger": "Button Danger",
  "button.warning": "Reactify Warning",
  "button.dark": "Button Dark",
  "button.orange": "Buttons Orange",
  "button.turquoise": "Button Turquoise",
  "button.green": "Button Green",
  "button.yellow": "Button Yellow",
  "button.purple": "Button Purple",
  "button.aqua": "Button Aqua",
  "button.brown": "Reactify Brown",
  "button.light-green": "Light Green",
  "button.success": "Button Success",
  "button.outline": "Outline Buttons",
  "button.with-icons": "Button With Icons",
  "icon.button": "Icon Button",
  "button.sizes": "Buttons with Sizing",
  "button.large-button": "Large Button",
  "button.regular-button": "Regular Button",
  "button.small-button": "Small Button",
  "button.very-small-button": "Very Small Button",
  "button.disabled": "Disabled Button",
  "button.block-button": "Block Button",
  "button.social": "Social Buttons With Icons",
  "button.more-social": "More Social Buttons",
  "button.services": "Services",
  "button.content-sites": "Content Sites",
  "button.gaming-sites": "Gaming Sites",
  "button.misc-buttons": "Misc Buttons",
  "button.store-button": "Store Buttons",
  "button.rounded-buttons": "Rounded Buttons",
  "button.with-badges": "Buttons With Badges",
  "button.heading-badges": "Heading With Badges",
  "modal.modal-normal": "Normal Modal",
  "modal.modals-": "Different Modals",
  "modal.large-modal": "Large Modals",
  "modal.variation-modal": "Variation Modal",
  "modal.backdrop-status": "Choose Backdrop Status/Value",
  "modal.nested-modal": "Nested Modals",
  "modal.narrow-modal": "Narrow Modals",
  "modal.wide-modal": "Wide Modals",
  "tooltip.variation": "Tooltip Variations",
  "tooltip.in-the-link": "Tooltip in The Link",
  "tooltip.placements": "Tooltip With Different Placements",
  "tooltip.UncontrolledTooltip": "UncontrolledTooltip",
  "popover.examples": "Popover Example",
  "popover.placements": "Popover Placements",
  "popover.top": "Popover Top",
  "popover.bottom": "Popover Bottom",
  "popover.right": "Popover Right",
  "popover.left": "Popover Left",
  "carousel.wide": "Full Width Carousel",
  "carousel.team": "Team Carousel",
  "carousel.post": "Posts Carousel",
  "forms-inline": "Inline Form",
  "forms.username": "Username",
  "forms.username-required": "Username is Required",
  "forms.password": "Password",
  "forms.password-required": "Password is Required",
  "forms.login": "Login",
  "menu.forms-input": "Form Inputs",
  "menu.forms-inputs": "Form Inputs",
  "products.add-new": "Add New Item",

  // App UIs

  "menu.apexcharts": "ApexChart",
  "menu.sparkline": "Sparkline",
  "menu.chartjs": "ChartJS",
  "menu.extras": "Extra Pages",
  "menu.login": "Login",
  "menu.register": "Register",
  "menu.forgot.password": "Forgot Password",
  "menu.products.page": "Products Page",
  "menu.products-page": "Products Page",
  "products.add-new-items": "Add New Item",
  "product-name": "Item Name",
  "product.category": "Item Category",
  "product.description": "Item Description",
  "product.status": "Status",
  "product.cancel": "Cancel",
  "product.submit": "Submit",
  "products.edit-item": "Edit product",
  "products.delete-item": "Delete product",
  "products.delete-confirm-title": "Remove this product?",
  "products.delete-confirm-body":
    "This removes the product from the current list. This demo does not call a server.",
  "products.save-changes": "Save changes",
  "products.delete-confirm": "Delete",
  "team-message.quick-actions": "Quick actions",
  "team-message.placeholder-call": "Start call",
  "team-message.placeholder-video": "Video",
  "error.go-home": "Go to Homepage",
  "menu.no-dropdown": "Without Dropdown",
  "menu.menu": "Dropdown",
  "menu.carousels": "Carousels",
  "menu.blank-page": "Blank Page",
  "menu.blankpage": "Blank Page",
  "menu.blank": "Blank",
  "menu.mails": "Mails",
  "menu.compose-mails": "Compose E-Mail",

  // Emails

  "emails.inbox": "Inbox",
  "emails.draft": "Draft",
  "emails.trash": "Trash",
  "emails.sent": "Sent",
  "emails.spam": "Spam",
  "emails.user-folders": "User Folders",
  "emails.address-book": "Address Book",
  "emails.send": "Send E-Mail",
  "menu.richeditor": "Rich Editor",
  "menu.rich-editor": "Rich Text Editor",
  "menu.editor": "Editor"
};

export default messages;
